import ErrorMessage from 'components/ErrorMessage'
import useToastContext from 'hooks/useToastContext'
import React, { useContext, useRef, useState, useEffect } from 'react'
import { useForm } from 'react-hook-form'
import FormData from 'form-data'
import AuthContext from 'context/AuthContext'
import OButton from 'components/reusable/OButton'
import { AiFillCamera } from 'react-icons/ai'
import { isEmpty } from 'lodash'
import OImage from 'components/reusable/OImage'
import { validationRules } from 'utils/constants'
import { useTranslation } from 'react-i18next'
import dayjs from 'dayjs'
import helpers from '../../utils/helpers'
const Profile = () => {
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors, isDirty, dirtyFields }
  } = useForm({ mode: 'onChange', shouldFocusError: true, defaultValues: {  } })
  const [profilePicError, setProfilePicError] = useState('')
  const [updateProfileLoading, setUpdatePrfileLoading] = useState(false)
  const [profilePic, setProfilePic] = useState(null)
  const notification = useToastContext()
  const { t } = useTranslation()
  const { updateProfile, user, loginMessage } = useContext(AuthContext)
  const profilePicRef = useRef()


  useEffect(() => {
    reset({
      firstName: (user.firstName).trim(),
      lastName: (user.lastName).trim(),
      mobile: user.mobile,
      email: user.email,
      lastUpdate: user?.lastUpdate ? dayjs(user?.lastUpdate).format('DD-MM-YYYY') : ''
    })
  }, [user])

  const handleSubmitForm = async (data) => {
    try {
      setUpdatePrfileLoading(true)
      const formData = new FormData()
      formData.append('firstName', data.firstName)
      formData.append('lastName', data.lastName)
      formData.append('mobile', data.mobile)
      formData.append('email', data.email)
      formData.append('profilePic', profilePic)
      reset()
      updateProfile(formData)
    } catch (err) {
      console.log('err:', err)
    } finally {
      setUpdatePrfileLoading(false)
      notification.success(loginMessage)
    }
  }

  const validateFiles = (profilePic) => {
    let picError = ''
    const supportedTypes = ['image/jpeg', 'image/jpg', 'image/png']

    if (!isEmpty(supportedTypes.includes(profilePic.type))) {
      picError = 'Only jpeg, jpg and png are supported.'
    }
    if (picError) {
      setProfilePicError(picError)
      return false
    } else {
      setProfilePicError('')
      return true
    }
  }

  const handleFileChange = (e) => {
    const image = e?.target?.files[0]
    const isValidImage = validateFiles(image)
    if (isValidImage) {
      setProfilePic(image)
    } else {
      setProfilePic(null)
    }
  }

  return (
    <div className='bg-[#F9F9F9]'>
      <div className='px-3 py-4'>
        <div className='bg-white border border-[#E9EDF9] rounded-lg py-4 '>
          <form onSubmit={handleSubmit(handleSubmitForm)} method='post'>
            <div className='grid lg:grid-cols-3 sm:grid-cols-2'>
              <div className='py-4 px-4 md:px-8'>
                <label className='block mb-2 text-sm font-medium text-gray-900 dark:text-white'>
                  {t('O_FIRST_NAME')}
                </label>
                <div className='relative'>
                  <div className='flex absolute inset-y-0 left-0 items-center pl-3 pointer-events-none' />
                  <input
                    type='text'
                    name='firstName'
                    id='firstName'
                    {...register('firstName', {
                      required: 'Please enter first name.',
                      pattern: {
                        value: validationRules.characters,
                        message: 'Invalid first name.'
                      },
                      minLength: {
                        value: 2,
                        message: 'First name should contain at least 2 characters.'
                      },
                      maxLength: {
                        value: 15,
                        message: 'First name should not exceed 15 characters.'
                      },
                      validate: value => {
                        return value.trim() ? true : 'White spaces not allowed.'
                      }
                    })}
                    placeholder='Enter first name.'
                    className='bg-gray-50 border outline-none border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full pl-4 p-2.5  dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500'
                  />
                  <ErrorMessage message={errors?.firstName?.message} />
                </div>
              </div>


              <div className='py-4 px-4 md:px-8'>
                <label className='block mb-2 text-sm font-medium text-gray-900 dark:text-white'>
                {t('O_LAST_NAME')}
                </label>
                <div className='relative'>
                  <div className='flex absolute inset-y-0 left-0 items-center pl-3 pointer-events-none' />
                  <input
                    type='text'
                    name='lastName'
                    id='lastName'
                    {...register('lastName', {
                      required: 'Please enter last name.',
                      pattern: {
                        value: validationRules.characters,
                        message: 'Invalid last name.'
                      },
                      minLength: {
                        value: 2,
                        message: 'Last name should contain at least 2 characters.'
                      },
                      maxLength: {
                        value: 15,
                        message: 'Last name should not exceed 15 characters.'
                      },
                      validate: value => {
                        return value.trim() ? true : 'White spaces not allowed.'
                      }
                    })}
                    placeholder='Enter last name'
                    className='bg-gray-50 border outline-none border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full pl-4 p-2.5  dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500'
                  />
                  <ErrorMessage message={errors?.lastName?.message} />
                </div>
              </div>


              <div className='py-4 px-4 md:px-8'>
                <label className='block mb-2 text-sm font-medium text-gray-900 dark:text-white'>
                  {t('O_MOBILE_NUMBER')}
                </label>
                <div className='relative'>
                  <div className='flex absolute inset-y-0 left-0 items-center pl-3 pointer-events-none' />
                  <input
                    type='number'
                    id='mobile'
                    className='bg-gray-50 border outline-none border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full pl-4 p-2.5  dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500'
                    placeholder=' '
                    // onInput={(e) => preventMax(e)}
                    // onKeyDown={(e) => {
                    //   if (['-', '+', 'e'].includes(e.key)) {
                    //     e.preventDefault()
                    //   }
                    // }}
                    {...register('mobile', {
                      required: 'Please enter valid mobile number.',
                      minLength: {
                        value: 9,
                        message: 'Min length should be 9 digits.'
                      },
                      maxLength: {
                        value: 15,
                        message: 'Max length should be 15 digits.'
                      },
                      pattern: {
                        value: validationRules.numbers,
                        message: 'Invalid mobile number.'
                      },
                      min: {
                        value: 0,
                        message: "Value can't be less than 0."
                      },
                      validate: value => {
                        return value[0] === '0' ? 'Mobile number cannot start with 0' : true
                      }
                    })}
                  />
                  <ErrorMessage message={errors?.mobile?.message} />
                </div>
              </div>
              <div className='py-4 px-4 md:px-8'>
                <label className='block mb-2 text-sm font-medium text-gray-900 dark:text-white'>
                  {t('LOGIN_EMAIL')}
                </label>
                <div className='relative'>
                  <div className='flex absolute inset-y-0 left-0 items-center pl-3 pointer-events-none' />
                  <input
                    type='test'
                    id='email'
                    disabled
                    className='bg-gray-50 border outline-none border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full pl-4 p-2.5  dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500'
                    placeholder=' '
                    {...register('email', {
                      // required: 'Please enter valid mobile number.',
                    })}
                  />
                  <ErrorMessage message={errors?.email?.message} />
                </div>
              </div>


              {/* profile pic  */}
              <div>
                <div className='py-4 flex justify-center'>
                  <div className='relative w-24 h-24 '>
                    <label className='block mb-2 text-sm font-medium text-gray-900 dark:text-white w-28'>
                      Profile picture
                    </label>
                    <input
                      type='file'
                      accept='image/png, image/jpg, image/jpeg'
                      name='image'
                      ref={profilePicRef}
                      onChange={handleFileChange}
                      className='hidden'
                    />

                    <OImage
                      src={
                        profilePic
                          ? URL.createObjectURL(profilePic)
                          : user?.profilePic
                      }
                      fallbackUrl='/images/user.png'
                      className='w-24 h-24'
                      alt=''
                      style={{ borderRadius: '50%' }}
                    />
                    <AiFillCamera
                      className=' bg-gray-100  absolute w-4 rounded-xl cursor-pointer'
                      style={{
                        width: '1.5rem',
                        height: '1.5rem',
                        bottom: '-23px',
                        right: 0,
                        background: '',
                        padding: '1px'
                      }}
                      onClick={() => profilePicRef?.current?.click()}
                    />
                  </div>
                </div>
                <div className='text-center mt-4'>
                  <ErrorMessage message={profilePicError} />
                </div>
              </div>

              {/* profile pic ends here  */}
            </div>
            <div className='flex justify-center mt-4'>
              <OButton
                disabled={!isDirty && profilePic == null}
                label='Submit'
                type='submit'
                loading={updateProfileLoading}
              />
            </div>
            <div class='px-6 py-4 text-sm whitespace-nowrap'>
              <div className='flex'>
                <h4 class='text-gray-700 dark:text-gray-200 mr-3'>
                  {t('O_LAST_UPDATED')}
                </h4>
                <p class='text-gray-500 dark:text-gray-400'>
                  {' '}
                  {helpers.dateFormat(user?.lastUpdate)}
                </p>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  )
}

export default Profile
